module.exports = __webpack_public_path__ + "img/wap_logo@2x.1bf9fc71.png";